import * as types from '../../index';

export const ppSettingsListAction = (data) => {
    return {
    type: types.OMNU_POINTS_PP_LIST,
    data
    }
};

export const ppSettingsAddAction = (data) => {
    return {
    type: types.OMNU_POINTS_PP_ADD,
    data
    }
};

export const ppSettingsEditAction = (data) => {
    return {
    type: types.OMNU_POINTS_PP_EDIT,
    data
    }
};

export const ppSettingsUpdateAction = (data) => {
    return {
    type: types.OMNU_POINTS_PP_UPDATE,
    data
    }
};

export const ppSettingsDeleteAction = (data) => {
    return {
    type: types.OMNU_POINTS_PP_DELETE,
    data
    }
};